import { MenuItem } from '@web/base/core/menu/menu-item.model';
import { Constants } from '@web/base/shared/constants.class';

export class ConstantsProject extends Constants {

  static COOKIES_CONSENT = '__CositalCookiesConsent';
  static COOKIES_CHAT_AI = '__CositalCookiesChatAI';

  static PROJECT_LOCATION = { lat: 40.415546, lng: -3.703524 };

  static MENU_SIDENAV: Array<MenuItem> = [];

  // static GOOGLE_MAPS_GEOCODING_API_KEY = 'AIzaSyDFUyoC6tCEjbkp7SqkR9WRn2ZTNpyyUjk';
  static GOOGLE_MAPS_GEOCODING_API_KEY = 'AIzaSyBgMSiqlBmJxzVY7lmTAqCWmVu8p3L047c';

  static MENU_HEADER: Array<MenuItem> = [
    {
      title: 'project', url: '',
      svgIcon: 'ico-project',
      children: [
        { title: 'information', header: true },
        { title: 'presentation', url: '/p/11/proyecto-esperanto' },
        { title: 'collaborators', url: '/p/38/colaboradores' },
        { title: 'sponsors', url: '/p/39/patrocinadores', },
        { title: 'subscriptions', url: '/informacion/suscripciones' },
        { title: 'provincialCouncils', url: '/p/40/diputaciones-provinciales' },
        { title: 'externalServices', url: '/p/41/servicios-externos' },
        { title: 'contact', url: '/informacion/contacto' },
        { title: 'protocols', header: true },
        { title: 'presentation', url: '/p/42/presentacion-de-protocolos' },
        { title: 'bullying', url: '/contenidos/2/protocolo-de-acoso-laboral' },
        {
          title: 'circulars',
          url: '',
          children: [
            { title: 'presentation', url: '/p/43/circulares-presentacion' },
            { title: 'mixed', url: '/contenidos/3/circulares-mixtas' },
            { title: 'secretary', url: '/contenidos/24/circulares-secretaria' },
            { title: 'intervention', url: '/contenidos/25/circulares-intervencion' },
            { title: 'treasury', url: '/contenidos/26/circulares-tesoreria' },
          ]
        },
        { title: 'dana', url: '/catastrofes/informacion' },
      ]
    },
    {
      title: 'observatories',
      url: '',
      svgIcon: 'ico-observatories',
      children: [
        { title: 'presentation', url: '/p/44/observatorios-presentacion' },
        // De forma dinámica se añaden los observatorios
        // { title: 'observatories', url: '' },
      ],
      classList: 'observatories'
    },
    {
      title: 'portals',
      svgIcon: 'ico-portals',
      children: [
        // De forma dinámica se añaden los portales
        // { title: 'portals', url: '' },
      ],
      classList: 'portals'
    },
    {
      title: 'models',
      svgIcon: 'ico-models',
      children: [
        { title: 'modelObservatory2', url: 'observatorios/2/contenidos/675/modelos' },
        { title: 'modelObservatory11', url: 'portales/11/portal-de-control-interno/contenidos/7050/modelos' },
        { title: 'modelObservatory3', url: 'observatorios/3/contenidos/6121/modelos-endeudamiento' },
        { title: 'modelObservatory4', url: 'observatorios/4/contenidos/645/modelos-estabilidad-presupuestaria' },
        { title: 'modelObservatory5', url: 'observatorios/5/contenidos/680/modelos-recaudacion' },
        { title: 'modelObservatory5.1', url: 'observatorios/5/contenidos/6910/modelos-recaudacion' },
        { title: 'modelObservatory8', url: 'observatorios/8/contenidos/678/guias-y-modelos-adaptados-ley-27-2013' },
        { title: 'modelObservatory12', url: 'portales/12/portal-de-tesoreria/contenidos/6729/modelos-tesoreria' },
        // descomentar cuando Judith de el visto bueno R91Y6mj48xd03PV3
        // { title: 'modelObservatory13', url: 'portales/14/portal-de-secretaria/contenidos/7366/modelos-portal-de-secretaria' },
      ]
    },
    {
      title: 'queries',
      svgIcon: 'ico-queries',
      children: [
        { title: 'presentation', url: '/consultas/presentacion' }
      ]
    },
    {
      title: 'education',
      svgIcon: 'ico-formation',
      children: [
        { title: 'online', url: '/cursos/1/online' },
        { title: 'faceToFace', url: '/cursos/2/jornadas' },
        { title: 'masterPrograms', url: '/titulos-universitarios' },
        { title: 'descentralized', url: '/cursos/3/descentralizada' },
        { title: 'campus', url: 'https://campus.cositalnetwork.es/', external: true },
      ],
      classList: 'formation'
    },
    { title: 'products', url: '/productos', svgIcon: 'ico-products', classList: 'products' }
  ];


  constructor() {
    super();
  }
}
